import { render, staticRenderFns } from "./rated-voltages.view.vue?vue&type=template&id=68a77c04&"
import script from "./rated-voltages.view.vue?vue&type=script&lang=ts&"
export * from "./rated-voltages.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports